<script>
import { badgeVariants } from 'next/polaris/ui/badge';
import { cn } from 'next/polaris/lib/utils';
import Icon from 'next/icon/Icon.vue';

export default {
  components: { Icon },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: '',
    },
  },
  emits: ['remove'],
  computed: {
    // The kit's outline badge for every variant (smooth, dashed, …): the label's own color only
    // ever paints the dot, never the chip. `dashed` is the one variant that still changes the look.
    labelClass() {
      return cn(
        badgeVariants({ variant: 'outline' }),
        'label gap-1.5 ltr:mr-1 rtl:ml-1 mb-1',
        this.small ? 'h-5 px-1.5' : 'h-6 px-2',
        this.variant === 'dashed' && 'border-dashed'
      );
    },
  },
  methods: {
    onClick() {
      this.$emit('remove', this.title);
    },
  },
};
</script>

<template>
  <div :class="labelClass" :title="description">
    <span
      v-if="color && title"
      class="size-2 shrink-0 rounded-full"
      :style="{ background: color }"
      aria-hidden="true"
    />
    <fluent-icon
      v-else-if="icon"
      :icon="icon"
      size="12"
      class="flex-shrink-0 cursor-pointer"
    />
    <span v-if="!href" class="whitespace-nowrap text-ellipsis overflow-hidden">
      {{ title }}
    </span>
    <a v-else :href="href" class="underline-offset-4 hover:underline">
      {{ title }}
    </a>
    <button
      v-if="showClose"
      type="button"
      :aria-label="$t('LABEL_MGMT.REMOVE_LABEL', { name: title })"
      class="-mr-1 grid size-4 place-items-center rounded-full hover:bg-polaris-accent"
      @click="onClick"
    >
      <Icon icon="i-lucide-x" class="size-3" />
    </button>
  </div>
</template>
